import { nanoid } from 'nanoid';
import { runtime } from '../../runtime/Runtime';
import { xa } from '../../../utils/xa/xa';
export class AppTrack {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get app() {
        return this.parent;
    }
    trackEvent(data) {
        runtime.runtimeScheduler.scheduleIdleBackgroundTask(() => {
            if (!data.id) {
                data.id = nanoid(12);
            }
            xa.user.track(data);
        });
    }
}
